import {SubmenuItem} from 'features/template/viewModels/standardPage';
import {FeaturedItem, Tag} from "features/search/types";

export interface ViewModel {
    siteId: string;
    header: string;
    tags: Tag[];
    searchTag: Tag;
    featuredSearches: FeaturedItem[];
    suggestedTags: Tag[];
    subMenu?: SubmenuItem[];
    showPlotType?: boolean;
    showSemiDetachedHouseType?: boolean;
}

export enum BlockType {
    Interest = 'interests',
    Favorite = 'favorites',
    Purchase = 'purchases',
    Showings = 'showings',
    All = 'all',
}

export enum ObjectImageType {
    Document = '0',
    Exterior = '1',
    Interior = '2',
    Planing = '3',
    FloorPlan = '4',
    Situation = '5',
    Other = '6',
    None = '7',
    AltFloorPlan = '8',
}
